import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdaptFeatureModule } from "@common/feature/feature.module";
import { AdaptCommonProgressModule } from "@common/progress/common-progress.module";
import { AdaptShellModule } from "@common/shell/shell.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxNumberBoxModule, DxRadioGroupModule, DxSelectBoxModule, DxTagBoxModule, DxTextBoxModule, DxValidatorModule } from "devextreme-angular";
import { CacheStatusPageComponent } from "./cache-status-page/cache-status-page.component";
import { cacheStatusPageRoute } from "./cache-status-page/cache-status-page.route";
import { CheckMyMathsComponent } from "./check-my-maths/check-my-maths.component";
import { ConfigureOrganisationFeaturesComponent } from "./configure-organisation-features/configure-organisation-features.component";
import { configureOrganisationFeaturesRoute } from "./configure-organisation-features/configure-organisation-features.route";
import { CopyMeetingOrTemplatePageComponent } from "./copy-meeting-or-template-page/copy-meeting-or-template-page.component";
import { copyMeetingOrTemplatePageRoute } from "./copy-meeting-or-template-page/copy-meeting-or-template-page.route";
import { CopySystemPageComponent } from "./copy-system-page/copy-system-page.component";
import { copySystemPageRoute } from "./copy-system-page/copy-system-page.route";
import { CopyTeamPageComponent } from "./copy-team-page/copy-team-page.component";
import { copyTeamPageRoute } from "./copy-team-page/copy-team-page.route";
import { DeleteOrganisationPageComponent } from "./delete-organisation-page/delete-organisation-page.component";
import { deleteOrganisationPageRoute } from "./delete-organisation-page/delete-organisation-page.route";
import { DeleteOrphanPeopleComponent } from "./delete-orphan-people-page/delete-orphan-people-page.component";
import { deleteOrphanPeoplePageRoute } from "./delete-orphan-people-page/delete-orphan-people-page.route";
import { DeleteOrphanUsersComponent } from "./delete-orphan-users-page/delete-orphan-users-page.component";
import { deleteOrphanUsersPageRoute } from "./delete-orphan-users-page/delete-orphan-users-page.route";
import { DeleteSurveyPageComponent } from "./delete-survey-page/delete-survey-page.component";
import { deleteSurveyPageRoute } from "./delete-survey-page/delete-survey-page.route";
import { DeleteUserPageComponent } from "./delete-user-page/delete-user-page.component";
import { deleteUserPageRoute } from "./delete-user-page/delete-user-page.route";
import { ExportLeadersOwnersComponent } from "./export-leaders-owners/export-leaders-owners.component";
import { exportLeadersOwnersRoute } from "./export-leaders-owners/export-leaders-owners.route";
import { ListPrivilegedUsersPageComponent } from "./list-privileged-users-page/list-privileged-users-page.component";
import { listPrivilegedUsersRoute } from "./list-privileged-users-page/list-privileged-users-page.route";
import { McpOAuthClientDialogComponent } from "./mcp-oauth-client-dialog/mcp-oauth-client-dialog.component";
import { McpOAuthClientsPageComponent } from "./mcp-oauth-clients-page/mcp-oauth-clients-page.component";
import { mcpOAuthClientsPageRoute } from "./mcp-oauth-clients-page/mcp-oauth-clients-page.route";
import { MergeUsersPageComponent } from "./merge-users-page/merge-users-page.component";
import { mergeUsersPageRoute } from "./merge-users-page/merge-users-page.route";
import { MoveBoardPageComponent } from "./move-board-page/move-board-page.component";
import { moveBoardPageRoute } from "./move-board-page/move-board-page.route";
import { SeedDatabasePageComponent } from "./seed-database-page/seed-database-page.component";
import { seedDatabasePageRoute } from "./seed-database-page/seed-database-page.route";
import { SeedTrainingOrganisationsComponent } from "./seed-training-organisations/seed-training-organisations.component";
import { seedTrainingOrganisationRoute } from "./seed-training-organisations/seed-training-organisations.route";
import { SelectBoardComponent } from "./select-board/select-board.component";
import { SelectMeetingOrTemplateComponent } from "./select-meeting-or-template/select-meeting-or-template.component";
import { SelectOrganisationComponent } from "./select-organisation/select-organisation.component";
import { SelectPersonComponent } from "./select-person/select-person.component";
import { SelectRoleComponent } from "./select-role/select-role.component";
import { SelectSurveyComponent } from "./select-survey/select-survey.component";
import { SelectSystemComponent } from "./select-system/select-system.component";
import { SelectTeamComponent } from "./select-team/select-team.component";
import { StakeholderServicesService } from "./stakeholder-services.service";
import { TriggerEventSchedulerComponent } from "./trigger-event-scheduler/trigger-event-scheduler.component";
import { triggerEventSchedulerRoute } from "./trigger-event-scheduler/trigger-event-scheduler.route";
import { TriggerStewardshipActivityComponent } from "./trigger-stewardship-activity/trigger-stewardship-activity.component";
import { triggerStewardshipActivityRoute } from "./trigger-stewardship-activity/trigger-stewardship-activity.route";
import { TriggerSurveySchedulerComponent } from "./trigger-survey-scheduler/trigger-survey-scheduler.component";
import { triggerSurveySchedulerRoute } from "./trigger-survey-scheduler/trigger-survey-scheduler.route";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AdaptButtonModule,
        AdaptCommonDialogModule,
        AdaptFeatureModule,
        AdaptShellModule,
        DxDataGridModule,
        DxCheckBoxModule,
        AdaptLoadingSpinnerModule,
        DxNumberBoxModule,
        DxValidatorModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxRadioGroupModule,
        AdaptDateModule,
        DxTagBoxModule,
        DxCheckBoxModule,
        AdaptCommonProgressModule,
        AdaptTooltipModule,
    ],
    declarations: [
        SelectOrganisationComponent,
        SelectMeetingOrTemplateComponent,
        ConfigureOrganisationFeaturesComponent,
        SeedTrainingOrganisationsComponent,
        TriggerSurveySchedulerComponent,
        ListPrivilegedUsersPageComponent,
        MergeUsersPageComponent,
        CheckMyMathsComponent,
        DeleteUserPageComponent,
        DeleteOrphanPeopleComponent,
        DeleteOrphanUsersComponent,
        SelectTeamComponent,
        MoveBoardPageComponent,
        SelectBoardComponent,
        DeleteOrganisationPageComponent,
        CacheStatusPageComponent,
        SeedDatabasePageComponent,
        TriggerStewardshipActivityComponent,
        DeleteSurveyPageComponent,
        SelectSurveyComponent,
        CopySystemPageComponent,
        SelectSystemComponent,
        SelectRoleComponent,
        CopyTeamPageComponent,
        SelectPersonComponent,
        CopyMeetingOrTemplatePageComponent,
        TriggerEventSchedulerComponent,
        ExportLeadersOwnersComponent,
        McpOAuthClientDialogComponent,
        McpOAuthClientsPageComponent,
    ],
    providers: [
        StakeholderServicesService,
    ],
    exports: [
        SelectOrganisationComponent,
        SelectPersonComponent,
    ],
})
export class AdaptToolsModule {
    public static readonly Routes = [
        ...cacheStatusPageRoute.routes,
        ...configureOrganisationFeaturesRoute.routes,
        ...copySystemPageRoute.routes,
        ...copyTeamPageRoute.routes,
        ...deleteOrganisationPageRoute.routes,
        ...deleteOrphanPeoplePageRoute.routes,
        ...deleteOrphanUsersPageRoute.routes,
        ...deleteSurveyPageRoute.routes,
        ...deleteUserPageRoute.routes,
        ...listPrivilegedUsersRoute.routes,
        ...mergeUsersPageRoute.routes,
        ...moveBoardPageRoute.routes,
        ...seedDatabasePageRoute.routes,
        ...seedTrainingOrganisationRoute.routes,
        ...triggerStewardshipActivityRoute.routes,
        ...triggerSurveySchedulerRoute.routes,
        ...triggerEventSchedulerRoute.routes,
        ...copyMeetingOrTemplatePageRoute.routes,
        ...exportLeadersOwnersRoute.routes,
        ...mcpOAuthClientsPageRoute.routes,
    ];
}
